import { Grid, Box } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { useQueueStore } from '../context/use-queue-store';
import { colors } from '../../colors/colors';

export const LoadingQueueRow = observer(function LoadingQueueRow(): React.ReactElement {
    const { showsRowGutter, queueColumns } = useQueueStore().workspacePanel.queue;
    return (
        <Grid
            position="relative"
            borderBottom="1px solid"
            borderColor="border.default"
            templateColumns="var(--columns)"
        >
            {showsRowGutter ? <Box className="queue-row-gutter" /> : null}
            {queueColumns.map((column, columnName) => (
                <Box key={columnName} className="base-queue-cell">
                    <span className="base-queue-cell-content">
                        <Skeleton
                            baseColor={colors.skeletonBaseColor}
                            highlightColor={colors.skeletonHighlightColor}
                        />
                    </span>
                </Box>
            ))}
        </Grid>
    );
});
